import { DocumentationTabTypes } from '../../../types/enums/DocumentationTabTypes';
import { SortOrder } from '../../common/types';
import type { TagRow } from './types';
import type { DocumentationUserInputMetadataElement } from '../../../types/documentationUserInputs';

export const tagsGridDocumentationTabFields = [
  {
    field: DocumentationTabTypes.FIELDS,
    headerName: 'Fields',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.SF_AUTOMATIONS,
    headerName: 'SF Automations',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.VALIDATION_RULES,
    headerName: 'Validation rules',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.APEX,
    headerName: 'Apex',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.LAYOUTS,
    headerName: 'Layouts',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.RECORD_TYPES,
    headerName: 'Record types',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.SWEEP_AUTOMATIONS,
    headerName: 'Sweep automation',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.PLAYBOOK_ALERTS,
    headerName: 'Sweep alerts',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.ASSIGNMENTS,
    headerName: 'Assignment rules',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.SCHEDULED_ASSIGNMENTS,
    headerName: 'Scheduled assignment rules',
    showSortIcon: true,
  },
  {
    field: DocumentationTabTypes.MATCHING_DEDUPE,
    headerName: 'Dedupe and matching',
    showSortIcon: true,
  },
];

export const tagsColumns = [
  {
    field: 'name',
    headerName: 'Tag name',
    showSortIcon: true,
  },
  ...tagsGridDocumentationTabFields,
];

export const usersColumns = [
  {
    field: 'name',
    headerName: 'User name',
    showSortIcon: true,
  },
  ...tagsGridDocumentationTabFields,
];

export enum TagsAndUsersSortValues {
  name = '_name',
  count = 'count',
}

export const tagsSortOptions = [
  { label: 'Item Count', value: TagsAndUsersSortValues.count, sortOrder: SortOrder.DESC },
  { label: 'Name', value: TagsAndUsersSortValues.name, sortOrder: SortOrder.ASC },
];

export const sortTags = (rows: TagRow[], sortState: { sortBy: string; sortOrder: SortOrder }) => {
  return rows.sort((a, b) => {
    const key = sortState.sortBy as keyof TagRow;
    const aValue = a[key];
    const bValue = b[key];
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortState.sortOrder === SortOrder.ASC
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortState.sortOrder === SortOrder.DESC ? aValue - bValue : bValue - aValue;
    }

    return 0;
  });
};

export const userInputMetadataElementId = (el: DocumentationUserInputMetadataElement): string => {
  switch (el.source) {
    case 'salesforce':
      return el.element.metadataId;
    case 'automation':
      return el.sweepAutomation.automationId;
    case 'rollup':
      return el.sweepRollup.rollupId;
  }
};
